import React from 'react';

const Intro = () => {
    return (
        <div className='container mt-8 mb-8 border-4 border-rose-200 border-l-rose-500'>
            <h2 className='text-center'><span className='text-rose-500'>YOUR</span><span className='text-black'>FRAGRANCE</span></h2>
            <p>"Your Fragrance distributes fragrances around the world for a variety of fashion brands, celebrities and lifestyles.
                The corporate headquarters of Your Fragrance is located in Bronx, NewYork in USA.
                The company's mission is to distribute fragrances of recognized brands that attract a loyal and different clients.
                Our main customers are Perfume Wholesalers, Perfume Stores and Duty Free Shops."</p>
        </div>
    );
};

export default Intro;